import { TaxEstimateFilingStatus } from "@wingspanhq/wingspan-api-sdk";

/**
 * Filing-status options for the tax-profile form.
 *
 * v1 stored a `TaxFilingCode` ("S"/"M"/"H"/"MS"/"QW") on the member profile;
 * v3 has no persisted tax profile at all — `filingStatus` is only ever a
 * request input to `POST /v3/finance/tax-estimates` — so the form speaks the
 * SDK enum directly and there is no code to map.
 */
export const FILING_STATUS_OPTIONS = [
  {
    value: TaxEstimateFilingStatus.SINGLE,
    label: "Single"
  },
  {
    value: TaxEstimateFilingStatus.MARRIED_FILING_JOINTLY,
    label: "Married filing jointly"
  },
  {
    value: TaxEstimateFilingStatus.MARRIED_FILING_SEPARATELY,
    label: "Married filing separately"
  },
  {
    value: TaxEstimateFilingStatus.HEAD_OF_HOUSEHOLD,
    label: "Head of household"
  },
  {
    value: TaxEstimateFilingStatus.QUALIFYING_SURVIVING_SPOUSE,
    label: "Qualifying surviving spouse"
  }
];
